
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'MailingUnsubscribed',
})
export default class MailingUnsubscribed extends Vue {}
